import React, { useEffect, useRef, useState } from 'react';
import '../App.css';

interface WelcomePopupProps {
  onClose: () => void;
}

const WelcomePopup: React.FC<WelcomePopupProps> = ({ onClose }) => {
  const [isAtBottom, setIsAtBottom] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  // Check if user has scrolled to the bottom
  const handleScroll = () => {
    if (!popupRef.current) return;
    
    const { scrollTop, scrollHeight, clientHeight } = popupRef.current;
    // Consider "at bottom" when within 50px of the bottom
    const isBottom = scrollTop + clientHeight >= scrollHeight - 50;
    setIsAtBottom(isBottom);
  };

  // Add scroll event listener
  useEffect(() => {
    const popup = popupRef.current;
    if (popup) {
      popup.addEventListener('scroll', handleScroll);
      // Check once on mount
      handleScroll();
    }
    
    return () => {
      if (popup) {
        popup.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div className="welcome-popup-overlay">
      <div 
        className={`welcome-popup ${isAtBottom ? 'at-bottom' : ''}`}
        ref={popupRef}
      >
        <button className="welcome-popup-close" onClick={onClose}>×</button>
        
        <h2 className="welcome-popup-title">ברוכים הבאים למפת דרכים לחיפוש עבודה!</h2>
        
        <div className="welcome-popup-content">
          <div className="welcome-popup-author">
            <p className="welcome-popup-author-intro">
              <strong>היי, אני אלמוג!</strong> אני סטודנט למדעי המחשב, והיום עובד במיקרוסופט. במהלך התואר עבדתי ב-3 משרות שונות כסטודנט, והמדריך הזה נועד לחלוק איתכם את הידע שצברתי, בחינם!
            </p>
          </div>
          
          <p className="welcome-popup-intro">
            כלי זה נועד לסייע לך בניווט בתהליך חיפוש העבודה. הנה כמה טיפים לשימוש:
          </p>
          
          <div className="welcome-popup-instructions">
            <div className="instruction-item">
              <span className="instruction-icon">🔍</span>
              <div className="instruction-text">
                <strong>ניווט בצעדים העיקריים:</strong> לחץ על הצעדים הראשיים (המסודרים בעמודה) כדי לראות את מפת הדרכים המפורטת לכל שלב.
              </div>
            </div>
            
            <div className="instruction-item">
              <span className="instruction-icon">🔄</span>
              <div className="instruction-text">
                <strong>חזרה לתצוגה הראשית:</strong> בכל מפה משנית, לחץ על כפתור "חזרה לתפריט הראשי" כדי לחזור למפה המרכזית.
              </div>
            </div>
            
            <div className="instruction-item">
              <span className="instruction-icon">👆</span>
              <div className="instruction-text">
                <strong>הרחבת הצעדים:</strong> לחץ על כל צעד במפה כדי לקבל מידע מפורט יותר, טיפים וגישה לחומרי עזר.
              </div>
            </div>
            
            <div className="instruction-item">
              <span className="instruction-icon">🎓</span>
              <div className="instruction-text">
                <strong>לימוד מעמיק:</strong> חלק מהצעדים כוללים קישורים לסרטוני הדרכה. לחץ על הכפתור "לחץ למעבר עבור הסבר מפורט" כדי לצפות בהם.
              </div>
            </div>

            <div className="instruction-item">
              <span className="instruction-icon">💻</span>
              <div className="instruction-text">
                <strong>שימוש במחשב:</strong> מומלץ להשתמש במחשב לצורך חוויית שימוש מיטבית עם הכלי.
              </div>
            </div>
          </div>
          
          <div className="welcome-popup-footer">
            <button className="welcome-popup-button" onClick={onClose}>
              הבנתי, בואו נתחיל!
            </button>
          </div>

          {/* Scroll indicator for mobile */}
          {!isAtBottom && (
            <div className="scroll-indicator-container">
              <div className="scroll-indicator-text">גלול למטה לקריאת כל התוכן</div>
              <div className="scroll-indicator"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomePopup;